// extracted by mini-css-extract-plugin
export default {"box":"ClickOutside_box__Dr0hu"};